module.exports = __webpack_public_path__ + "static/img/building02.9446655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/objectIcons/building02.png
// module id = CjIm
// module chunks = 0